import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StringUtils {
    public buildUrl(...paths: String[]): string {
        return paths.join('');
    }
}